// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WSXz","content":"styles_content__1Ali0","row":"styles_row__JMT8c","footer":"styles_footer__2iucI","phraseLength":"styles_phraseLength__1fnM_"};